import Image from 'next/image';
import useDeviceDetect from 'react-scale/hooks/useDeviceDetect';

import { Section, SectionTitle, Box } from 'react-scale/components';

const DataCollection = () => {
  const { isMobile } = useDeviceDetect();

  return (
    <Section bg="bg-neutral-800">
      <SectionTitle
        themeColors={{ overtitleColor: '#AAD2FF' }}
        overtitle="data collection"
        title="The data was collected from Reddit using&nbsp;pushshift"
        subtitle="Build better models faster with data you can trust. Maximize operational efficiency and productivity while reducing the cost of ML&nbsp;projects."
      />

      <Box type="gradient" color="#AAD2FF" borderRadius={24}>
        <div className="py-14 px-8 md:p-14 space-y-8 lg:space-y-0 xl:py-[90px] xl:px-20 flex flex-col lg:flex-row lg:space-x-20 xl:space-x-[129px] lg:items-start justify-between">
          <Image
            width={isMobile ? 123 : 183}
            height={isMobile ? 64 : 96}
            layout="intrinsic"
            src="/static/images/pages/open-datasets/oxford/data-collection/scale-redit.svg"
            alt="scale redit"
          />
          <p className="flex-1 font-aeonik text-white sm:text-lg lg:text-xl xl:text-2xl mad-w-[720px] text-center lg:text-left">
            The pushshift.io Reddit API was designed and created by the /r/datasets mod team to help
            provide enhanced functionality
            <br className="hidden xl:block" />
            and search capabilities for searching Reddit comments and submissions. This RESTful API
            gives full functionality for searching Reddit data and also includes the capability of
            creating powerful
            <br className="hidden xl:block" />
            data aggregations. With this API, you can quickly find the data
            <br className="hidden xl:block" />
            that you are interested in and find fascinating&nbsp;correlations.
          </p>
        </div>
      </Box>
    </Section>
  );
};

export default DataCollection;
